<template>
<div class="admin-form">
    <h2>Administration Form</h2>

    <div class="md-form-input">
        <label for="dose_journaliere">Daily Dose (mg):</label>
        <input v-model="store.adminDailyDose" type="text" id="dose_journaliere" name="dose_journaliere">
    </div>

    <div class="md-form-input">
        <label for="nb_admin_jour">Number of administrations per day:</label>
        <input v-model="store.nbAdminJour" type="number" id="nb_admin_jour" name="nb_admin_jour">
    </div>

    <div class="md-form-input">
        <label for="unit_dose">Unit Dose (mg):</label>
        <input :value="unitDose" type="text" id="unit_dose" name="unit_dose" readonly>
    </div>

    <div class="md-form-input">
        <label for="mode_admin">Administration Mode:</label>
        <select v-model="store.modeAdmin" id="mode_admin" name="mode_admin">
            <option value="IV">IV</option>
            <option value="IVSE">IVSE (Continuous)</option>
            <option value="PO">PO</option>
        </select>
    </div>

    <div class="md-form-input" v-if="store.currentAtbDataRow && store.currentAtbDataRow['beta-lactamin '] === '1'">
        <label for="duree_perfusion">
            If IV: Infusion Duration (hours)
            :
        </label>
        <input v-model="store.durationIV" type="number" id="duree_perfusion" name="duree_perfusion" min="0" step="0.1" :disabled="store.modeAdmin !== 'IV'" :class="{ 'grayed-out': store.modeAdmin !== 'IV' }">
    </div>

    <div class="md-form-input">
        <label for="date_debut">Treatment Start Date:</label>
        <input v-model="store.adminStartDate" type="date" id="date_debut" name="date_debut">
    </div>

    <div class="md-form-input">
        <label for="date_heure_derniere_admin">Date and Time of Last Administration:</label>
        <input v-model="store.adminLastAdmin" type="datetime-local" id="date_heure_derniere_admin" name="date_heure_derniere_admin">
    </div>

    <div class="md-form-input">
        <label for="date_heure_prelevement">Date and Time of Sample Collection:</label>
        <input v-model="store.adminSampleCollection" type="datetime-local" id="date_heure_prelevement" name="date_heure_prelevement">
    </div>

</div>
</template>

<script setup>
import { computed } from 'vue';
import { useTestStore } from "@/stores/testStore";

const store = useTestStore();

const unitDose = computed(() => {
    if (!store.adminDailyDose || !store.nbAdminJour) {
        return null;
    }
    const dailyDose = parseFloat(store.adminDailyDose);
    const adminCount = parseFloat(store.nbAdminJour);
    if (isNaN(dailyDose) || isNaN(adminCount) || adminCount === 0) {
        return null;
    }
    return (dailyDose / adminCount).toFixed(2);
});
</script>

<style scoped>
.md-form-input {
    display: flex;
    align-items: center;
    gap: 10px;
    margin: 0px 0px 10px 10px;
}

.md-form-input label {
    width: 300px; /* Adjust width as needed */
    text-align: left;
}

.info-icon-container {
    position: relative;
    display: inline-block;
    margin-left: 5px;
}

.info-icon {
    display: inline-block;
    color: #308aeb;
    cursor: help;
    font-size: 14px;
    font-weight: bold;
    border-radius: 50%;
    width: 16px;
    height: 16px;
    text-align: center;
    line-height: 16px;
    background-color: transparent;
    border: 1px solid #007bff;
}

.info-icon:hover {
    background-color: #007bff;
    color: white;
}

.tooltip-text {
    visibility: hidden;
    width: 250px;
    background-color: #333;
    color: white;
    text-align: center;
    border-radius: 6px;
    padding: 8px;
    position: absolute;
    z-index: 1000;
    bottom: 125%;
    left: 50%;
    margin-left: -125px;
    opacity: 0;
    transition: opacity 0.2s;
    font-size: 12px;
    font-weight: normal;
    box-shadow: 0px 2px 8px rgba(0,0,0,0.2);
}

.tooltip-text::after {
    content: "";
    position: absolute;
    top: 100%;
    left: 50%;
    margin-left: -5px;
    border-width: 5px;
    border-style: solid;
    border-color: #333 transparent transparent transparent;
}

.info-icon-container:hover .tooltip-text {
    visibility: visible;
    opacity: 1;
}

.admin-form {
  padding: 10px 10px 50px 10px;
  margin: 30px 0px 0px 30px;
  border: rgb(204, 161, 161) 3px solid;
  border-radius: 15px;
}

.grayed-out {
  background-color: #f5f5f5;
  color: #999;
}


</style>